// import styles from './Footer.module.scss';
import classNames from "classnames";
import Input from "react-phone-input-2";
import styles from "../../../assets/scss/global.module.scss";
import "react-phone-input-2/lib/style.css";
import "./style.css";

interface InputProps {
  label?: string;
  placeholder?: string;
  value?: any;
  onChange?: any;
  onBlur?: any;
  error?: string | null;
  name?: string;
  disabled?: boolean;
  preferredCountries?: string[];
}

export function PhoneInput({
  name = "",
  label = "",
  placeholder = "",
  value = "",
  onChange,
  onBlur,
  error,
  disabled = false,
  ...props
}: InputProps) {
  // console.log(disabled);

  const classNamesForInput = classNames(
    styles["inputContainer"],
    error ? styles["inputError"] : "",
  );

  return (
    <div>
      <div className={classNamesForInput}>
        <label>{label}</label>
        <Input
          country={"us"}
          countryCodeEditable={false}
          inputProps={{
            name,
            placeholder,
          }}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          inputStyle={{
            paddingLeft: "55px",
          }}
          {...props}
        />
        {error && <span className={styles["errorMessage"]}>{error}</span>}
      </div>
    </div>
  );
}

export default PhoneInput;
